import * as bootstrap from 'bootstrap';

document.addEventListener('turbo:load', () => {
  var hash = window.location.hash;
  if (hash) {
    var tab = document.querySelector(`[data-bs-target="${hash}"]`);
    if (tab) {
      bootstrap.Tab.getOrCreateInstance(tab).show();
    }
  }
});

// Redirect form submission to include anchor
document.addEventListener("turbo:load", () => {
  const form = document.querySelector("form[data-anchor]");
  if (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();

      const anchor = form.dataset.anchor;
      const action = form.action.split("#")[0];
      const formData = new FormData(form);
      const queryString = new URLSearchParams(formData).toString();

      window.location.href = `${action}?${queryString}#${anchor}`;
    });
  }
});
